export default {
  state: {
    trackings: []
  },
  mutations: {
    setTracking (state, payload) {
      state.trackings.push(payload)
    }
  },
  actions: {
    setTracking ({commit}, payload) {
      commit('clearError')
      commit('setLoading', true)
      try {
        commit('setTracking', payload)
        commit('setLoading', false)
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
      }
    }
  },
  getters: {
    getTracking (state) {
      return trackingNum => {
        return state.trackings.find(tracking => tracking.id === trackingNum)
      }
    }
  }
}
